module.exports = __webpack_public_path__ + "static/media/icon-goup.509b193f.svg";